import { ReactNode, DOMAttributes, useEffect } from 'react';
import cn from 'classnames';
import styles from './styles.scss';
import TransitionGroup from 'react-transition-group-plus';
import { Overlay as OverlayOpacity } from 'components/Shared/Overlay/Overlay';
import { emptyFunction, isBrowser } from 'utils';
import layoutStyles from 'components/Pagelayout/styles.scss';

type OwnProps = Pick<
  DOMAttributes<HTMLDivElement>,
  'onClick' | 'onTouchStart' | 'onBlur' | 'onFocus'
> & {
  visible: boolean;
  transparent?: boolean;
  children?: ReactNode;
  wrapperClassname?: string;
  childrenClassname?: string;
  lockScroll?: boolean;
  isFilterOverlay?: boolean;
};
export default function Overlay({
  visible,
  transparent,
  onClick = emptyFunction,
  onTouchStart = emptyFunction,
  onBlur = emptyFunction,
  onFocus = emptyFunction,
  children,
  wrapperClassname,
  childrenClassname,
  lockScroll,
  isFilterOverlay
}: OwnProps) {
  useEffect(() => {
    if (!isBrowser() || !lockScroll) {
      return;
    }

    if (visible) {
      document.body.classList.add(layoutStyles.lockBody);
    } else {
      // unlock scroll
      document.body.classList.remove(layoutStyles.lockBody);
    }
  }, [visible, lockScroll]);
  return (
    <div
      onBlur={onBlur}
      onFocus={onFocus}
      className={cn(styles.base, wrapperClassname, {
        [styles.filterOverlay]: isFilterOverlay,
        [styles.visible]: visible
      })}
    >
      <TransitionGroup component="div">
        {visible && (
          <OverlayOpacity
            {...{
              transparent,
              onClick,
              onTouchStart,
              isFilterOverlay
            }}
          />
        )}
      </TransitionGroup>
      <div
        className={cn(styles.children, childrenClassname, {
          [styles.filterOverlay]: isFilterOverlay,
          [styles.visible]: !!visible
        })}
      >
        {children}
      </div>
    </div>
  );
}
